import * as React from 'react';
import { connect } from 'react-redux';

import {
  IDuplicateAndQuarantine,
  IProductInfo,
  IReferer,
  IState,
  IUserInfo
} from '../CustomTypes';

import LegalAge from '../gdpr/LegalAge';
import { svgGift } from '../icons';
import { Button } from '../input-components/InputComponents';
import { sccPulseTrackPageView } from '../PulseUtils';
import './ProductQuarantined.scss';
import { fetchUserInfoDeferred, productInfoDeferred } from '../actions/Actions';

export interface IProductQuarantinedParamProps {
  productInfo: IProductInfo;
  referer: IReferer;
  userInfo: IUserInfo;
  checkDuplicateAndQuarantine: IDuplicateAndQuarantine;
}

/**
 * This page is used when the subscription type is quarantined for the user
 */
export class ProductQuarantined extends React.Component<
  IProductQuarantinedParamProps
> {
  public componentDidMount() {
    const { quarantineUrl } = this.props.checkDuplicateAndQuarantine;
    productInfoDeferred.promise.then(product => {
      const eventName = 'Quarantine';
      fetchUserInfoDeferred.promise
        .then(user => {
          sccPulseTrackPageView(product, user, eventName, {
            offer: quarantineUrl
          });
        })
        .catch(e => {
          sccPulseTrackPageView(product, {}, eventName, {
            offer: quarantineUrl
          });
        });
    });
  }

  public render() {
    const { userInfo } = this.props;
    return (
      <div className="product-quarantined container">
        <h1>{svgGift()}</h1>
        <h1>
          Velkommen tilbake{userInfo.firstName ? `, ${userInfo.firstName}` : ''}
        </h1>
        <h4>
          Dette tilbudet er kun for nye abonnenter. Som tidligere abonnent kan
          du ha tilgang på en rabattert pris.
        </h4>
        <div className="col-xs-12">
          <Button onClick={this.onClickOffer}>Fortsett her</Button>
        </div>
        <LegalAge />
      </div>
    );
  }

  private onClickOffer = () => {
    const { quarantineUrl } = this.props.checkDuplicateAndQuarantine;
    const { spidId, sig } = this.props.userInfo;
    sccPulseTrackPageView(
      this.props.productInfo,
      this.props.userInfo,
      'Quarantine continue button clicked'
    );
    const referer = this.props.referer.referer || '';
    const firstParameterSeparator =
      quarantineUrl && quarantineUrl.includes('?') ? '&' : '?';
    const urlWithRefererAndSig = `${quarantineUrl ||
      ''}${firstParameterSeparator}spidId=${spidId}&sig=${encodeURIComponent(
      sig || ''
    )}&referer=${referer}`;
    window.location.href = urlWithRefererAndSig;
  };
}

export default connect(
  (state: IState) =>
    ({
      checkDuplicateAndQuarantine: state.checkDuplicateAndQuarantine,
      productInfo: state.productInfo,
      referer: state.referer,
      userInfo: state.userInfo
    } as IProductQuarantinedParamProps)
)(ProductQuarantined);



// WEBPACK FOOTER //
// ./src/page-components/ProductQuarantined.tsx